/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'
import _flatten from 'lodash/flatten'
import _forEach from 'lodash/forEach'

// 领主轮次状态
export enum LordRoundStatus {
  未开始 = 0,
  进行中 = 1,
  已结束 = 2,
}
// 普通与高级矿场
export enum MINEENUM {
  low = 0,
  high = 1,
  super = 2,
}
// 礼物等级 普通 R SR SSR
export enum GIFTENUM {
  N = 0,
  R = 1,
  SR = 2,
  SSR = 3,
}
// 0 禮物 1 碎片
export enum GIFTTYPEENUM {
  礼物 = 0,
  碎片 = 1,
}
// 任务领取状态
export enum STATUSENUM {
  不可领取 = 0,
  可领取 = 1,
  已领取 = 2,
}

export interface GiftType {
  prize_type: GIFTTYPEENUM
  prize_quality: GIFTENUM
  prize_icon: string
  prize_name: string
  prize_value: number
  gift_id: number
}

export interface NoticeType {
  area_code: number
  avatar: string
  name: string
  times: number // 开采次数
  prize_name: string
  prize_num: number // 奖励个数
}

export interface TaskType {
  id: number
  level_num: number // 档位对应的次数
  icon: string // 奖励图片
  coin_range: [number, number] // 金币范围 或者已领取的金币数值
  status: STATUSENUM // 领取状态
}

// 获取领主记录
export const golden_miner_lord_war_records = createAsyncThunk(
  'golden_miner_lord_war_records',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_lord_war_records',
      {
        offset: 0,
        limit: 1000,
        ...arg,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 获取首页信息
export const golden_miner_homepage = createAsyncThunk(
  'golden_miner_homepage',
  async (arg: {mine_type: MINEENUM}, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_homepage',
      {
        ...arg,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 获取记录
export const golden_miner_records = createAsyncThunk(
  'golden_miner_records',
  async (arg, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_records',
      {
        offset: 0,
        limit: 1000,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 下注挖矿 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151075316
// status 0 失败 1 成功 2 余额不足
export const golden_miner_mine = createAsyncThunk(
  'golden_miner_mine',
  async (arg: {mine_type: MINEENUM; mine_times: number}, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_mine',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 每周福利
export const golden_miner_weekly_tasks = createAsyncThunk(
  'golden_miner_weekly_tasks',
  async (arg: {mine_type: MINEENUM}, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_weekly_tasks',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 领取每周福利
export const golden_miner_weekly_tasks_reward = createAsyncThunk(
  'golden_miner_weekly_tasks_reward',
  async (arg: {mine_type: MINEENUM; mine_task_id: number}, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_weekly_tasks_reward',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

// 黄金矿工榜单接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151076943
export const golden_miner_rank = createAsyncThunk(
  'golden_miner_rank',
  async (arg: {mine_type: MINEENUM; mine_task_id: number}, store) => {
    const resp = await http.post(
      '/live/game/golden_miner_rank',
      {...arg},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

interface InitialStateType {
  base: {
    amountOptShow?: boolean // 选择框
    selectedMine?: number // 当前矿场选择
    showDigAmis?: boolean
    hasPreLoadedAct: boolean // 前置引导结束标志
    isLoading: boolean // 加载标志
    musicCanPlay: boolean // 音乐播放标志
    amisCanPlay: boolean // 动画播放标志
    showRewardTip: boolean // 是否展示奖励上面的提示
    processAddExp: number // 进度条增加
  }
  home: {
    level_info?: {
      bet_amounts: Array<number> // 下注的次数 数组
      bet_coins: number // 单词下注金币
      my_own_pieces_exp?: number // 集满所需碎片
      my_own_pieces?: number // 当前碎片
      prize_list: Array<GiftType> // 奖励列表
      max_rate: number // 奖励最高倍率
    }
    mine_notice?: Array<NoticeType> // 轮播内容
    mine_exps?: Array<{
      name: string
      exp: number
      award: number
    }>
    rules?: any
    is_first?: boolean // 第一次下注
    balance?: number // 当前金币
    exp?: number // 矿工经验
    exp_range?: Array<number> // 矿工经验范围
    level?: number // 矿工等级
    level_name?: string // 等级名称
    lord_war_info?: any // 领主信息
  }
  task?: {
    err_msg?: string // 错误
    countdown?: number // 倒计时
    weekly_num?: number // 本周抽奖总次数
    level_infos?: Array<TaskType> // 福利任务
  }
}
const initialState: InitialStateType = {
  base: {
    selectedMine: MINEENUM.low,
    hasPreLoadedAct: false,
    showDigAmis: true,
    processAddExp: 0,
    showRewardTip: false,
    amountOptShow: false,
    isLoading: true,
    musicCanPlay: false,
    amisCanPlay: false,
  },
  home: {},
  task: {},
}

export const GoldMinerSlice = createSlice({
  name: 'GoldMiner',
  initialState,
  reducers: {
    updateLordWarInfo: (state, action: PayloadAction<any>) => {
      const {lord_war_info = {}} = state.home
      Object.assign(state, {
        home: {
          ...state.home,
          lord_war_info: {
            ...lord_war_info,
            ...action.payload,
          },
        },
      })
    },
    changeMusicCanPlay: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          musicCanPlay: action.payload,
        },
      })
    },
    changeProcessAddExp: (state, action: PayloadAction<number>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          processAddExp: action.payload,
        },
      })
    },
    changeShowRewardTip: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          showRewardTip: action.payload,
        },
      })
    },
    changeAmisCanPlay: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          amisCanPlay: action.payload,
        },
      })
    },
    finishedLoading: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isLoading: false,
        },
      })
    },
    finishedPreLoadedAct: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          hasPreLoadedAct: true,
        },
      })
    },
    setSelectTab: (state, action: PayloadAction<MINEENUM>) => {
      const {base} = state
      // 设置下次进入默认的tab
      Object.assign(state, {
        base: {
          ...base,
          selectedMine: action.payload,
        },
      })
    },
    setAmountOptShow: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          amountOptShow: action.payload,
        },
      })
    },
    setShowDigAmis: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          showDigAmis: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    // 首页信息
    builder.addCase(golden_miner_homepage.fulfilled, (state, action) => {
      const data = action.payload
      Object.assign(state, {home: data})
    })
    // 每周福利
    builder.addCase(golden_miner_weekly_tasks.fulfilled, (state, action) => {
      const data = action.payload
      Object.assign(state, {task: data})
    })
  },
})
export default GoldMinerSlice.reducer
export const useGoldMinerState = () => {
  return useSelector((state) => state.Animal_Coyote)
}
export const GoldMinerActions = GoldMinerSlice.actions
